import { SortOrder } from '@electricjs/core_entity-client';
import { Select, Box, Text } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

import { SortingParams } from '@/types/common';

type SortingOption = {
  label: string;
  value: SortingParams;
};

type SortingSelectorProps = {
  width?: string;
  selectedSorting: SortingParams;
  onSortingSelect: (sorting: SortingParams) => void;
};

const SortingSelector = ({
  width,
  selectedSorting,
  onSortingSelect,
}: SortingSelectorProps) => {
  const { t } = useTranslation('common');

  const options: SortingOption[] = [
    {
      label: t('storefront.filters.sortOptions.nameAsc'),
      value: { orderBy: 'name', sortOrder: SortOrder.Asc },
    },
    {
      label: t('storefront.filters.sortOptions.nameDesc'),
      value: { orderBy: 'name', sortOrder: SortOrder.Desc },
    },
    {
      label: t('storefront.filters.sortOptions.priceDesc'),
      value: { orderBy: 'price', sortOrder: SortOrder.Desc },
    },
    {
      label: t('storefront.filters.sortOptions.priceAsc'),
      value: { orderBy: 'price', sortOrder: SortOrder.Asc },
    },
  ];

  const handleSelection = (option: SortingOption | null) => {
    if (option) {
      onSortingSelect({ ...option.value });
    }
  };

  return (
    <Box width={width}>
      <Text variant="label-large">{t('storefront.filters.sort')}</Text>
      <Select
        id="storefront-sorting-select"
        options={options}
        onChange={handleSelection}
        value={options.find(
          option =>
            option.value.orderBy === selectedSorting.orderBy &&
            option.value.sortOrder === selectedSorting.sortOrder
        )}
      />
    </Box>
  );
};

export default SortingSelector;
